import { Box, styled, themeGet } from '@qwealth/qcore';

export const StyledQNoteAuthorData = styled(Box)`
  margin-top: ${themeGet('space.large')};
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  column-gap: ${themeGet('space.large')};
  row-gap: ${themeGet('space.large')};

  .task-row {
    width: 100%;
    grid-column: 1 / span 4;
    display: flex;
    gap: ${themeGet('space.default')};
  }

  .task-row-select {
    flex-direction: row;
    align-items: flex-end;
  }

  .task-row-button {
    flex-direction: column;
    align-items: flex-start;
  }
`;
